<!-- 我的二维码 -->
<template>
  <div>
    <el-container class="container">
      <img class="img1" src="../../assets/images/mobile/newbj.png" />
      <el-header class="header">
        <div class="header-wrap">
          <img
            src="@/assets/images/mobile/return.png"
            class="header-img"
            @click="goBack"
          />
        </div>
        <!-- <p>我的二维码</p> -->
      </el-header>
      <el-main class="mainContent">
        <div style="margin: 0 auto; position: relative">
          <div style="text-align: center">
            <el-button v-if="!codeUrl"   plain @click="getmyqrcode">刷新</el-button>
          </div>
          <!--<div class="qyname">{{ userInfo.enterpriseInfo.enterprise }}</div>-->
          <img :src="codeUrl" alt="" style="max-width: 300px" />
          <p style="text-align:center;color:#fff;font-size:20px;margin-top:1rem">{{createTime}}</p>
          <p style="text-align:center;color:#fff;font-size:16px;margin-top:2rem;font-weight:bold">请长按图片，保存您的专属企业码</p>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      codeUrl: "",
      createTime:'',
      getCode:'',
    };
  },

  components: {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
  },
  created() {

  },
  mounted() {
    let self=this
    self.getCode=setTimeout(function () {
      self.getmyqrcode();
    },500)
  },
  methods: {
    goBack() {
      this.$router.push("/suqiuMobile");
    },
    getmyqrcode() {
      let seft=this
      let url = "/dev-api/sms/getTwoCodeImage";
      seft.$httpApi
        .get(url, {
          tyshxydm: seft.userInfo.tyshxydm,
        })
        .then((r) => {
          if (r.code == 200) {
            // seft.codeUrl = "data:image/png;base64," + r.img;
            seft.codeUrl = "http://36.133.218.216:8000/imgcode/" + r.imagename;
/*            if(r.enterprise.createTime) {
              let time = r.enterprise.createTime.split(' ')[0]
              let timearr = time.split('-')
              this.createTime = timearr[0] + '年' + timearr[1] + '月' + timearr[2] + '日'
            } else {
              let now = new Date()
              let year = now.getFullYear()
              let month = now.getMonth() + 1
              let day = now.getDate()
              month = month < 10 ? '0' + month : month
              day = day < 10 ? '0' + day : day
              this.createTime = year + '年' + month + '月' + day + '日'
            }*/
            let now = new Date()
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            let day = now.getDate()
            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day
            seft.createTime = year + '年' + month + '月' + day + '日'
            clearInterval(seft.getCode)
          }
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 100vw;
  height: 100vh;
  position: relative;
  .img1 {
    width: 100vw;
    height: 100vh;
    position: absolute;
  }
}
.header {
  z-index: 100;
  width: 100%;
  height: 5.25rem !important;
  // background-color: #36aa60;
  position: relative;
  .header-wrap {
    position: absolute;
    top: 0.625rem;
    left: 0.625rem;
    .header-img {
      width: 30px;
      height: 30px;
      // margin-top: 1rem;
    }
  }
  p {
    height: 20px;
    text-align: center;
    color: #fff;
    font-size: 22px;
    line-height: 4;
    letter-spacing: 0.5rem;
  }
}
.mainContent {
  padding-top: 0;
  height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  align-items: center;
  .qyname {
    width: 100%;
    text-align: center;
    position: absolute;
    top: -28px;
    left: 0;
    color: #fff;
    font-size: 1rem;
    letter-spacing: 1px;
    font-weight: 600;
  }
}
</style>
